import { Typography, ListItemText, Link } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';
import { goodPractisesLink, pageLink } from '../utils/urls';

const GeneralProvisions = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      1. Postanowienia ogólne.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>1.1.</ListItemIcon>
        <ListItemText>
          Ten Regulamin określa warunki świadczenia drogą elektroniczną Usług za
          pośrednictwem Serwisu znajdującego się pod adresem internetowym{' '}
          {pageLink} oraz tryb postępowania reklamacyjnego.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>1.2.</ListItemIcon>
        <ListItemText>
          Administrator świadczy Usługi zgodnie z Regulaminem, Polityką
          Prywatności i Cookies oraz z powszechnie obowiązującymi przepisami
          polskiego prawa.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>1.3.</ListItemIcon>
        <ListItemText>
          Administrator jako członek i współzałożyciel Związku Przedsiębiorstw
          Finansowych w Polsce, stosuje Zasady Dobrych Praktyk przedsiębiorstw
          zrzeszonych w Związku Przedsiębiorstw Finansowych w Polsce, dostępnych
          pod adresem:
          <Link
            href={goodPractisesLink}
            color="primary.light"
            target="_blank"
            rel="nofollow"
            data-link-no-alert
          >
            {' '}
            {goodPractisesLink}
          </Link>
          .
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default GeneralProvisions;
